<template>
    <div class="justify-content-around tx-screen-main-center">
        <div v-if="loading === true"><b-spinner style="width: 3rem; height: 3rem;" variant="primary"
                label="Large Spinner"></b-spinner></div>
        <div class="col-md-10" v-if="loading === false">
            <div class="row">
                <div class="p-2">
                    <h1 class="card-title">Health Care Entity Transaction</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="card">
                        <div class="card-header">
                            <h2>Sections</h2>
                        </div>
                        <div class="card-body">
                            <p>Complete the following sections and then Submit the transaction for review.
                            </p>
                            <div clas="container">
                                <div class="row">
                                    <div class="col-10"><button type="button" class="btn btn-link" style="color:green"
                                            @click="display = 'overview'">Overview</button>
                                    </div>
                                    <div class="col-2 d-flex align-items-center">

                                        <BIconCheckCircleFill style="color: green;" v-if="display === 'overview'">
                                        </BIconCheckCircleFill>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-10"><button type="button" class="btn btn-link" style="color:green"
                                            @click="display = 'generalinformation'">General
                                            Information</button></div>
                                    <div class="col-2 d-flex align-items-center">
                                        <BIconCheckCircleFill style="color: green;" v-if="display === 'generalinformation'">
                                        </BIconCheckCircleFill>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-10"><button type="button" class="btn btn-link" style="color:green"
                                            @click="display = 'documents'">Documents</button>
                                    </div>
                                    <div class="col-2 d-flex align-items-center">
                                        <BIconCheckCircleFill style="color: green;" v-if="display === 'documents'">
                                        </BIconCheckCircleFill>
                                    </div>
                                </div>
                            </div>
                            <div class='p-2'><b-alert show variant="primary"
                                    style="border: 1px solid; border-color: #aabbf2f9;">Pending
                                    Submission</b-alert></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="card">
                        <div class="card-body">
                            <div v-if="display === 'overview'">
                                <h2 class="card-title">Overview </h2>
                                <p class="card-sub-title text-muted">Please complete the data required under each section at the left. Once
                                    data has been entered and saved under the General Information tab, additional information
                                    and/or documents may be added or updated iteratively until all data values are complete.
                                </p>
                                <div class="d-flex align-items-center">
                                    <b-button variant="link" size="sm" style="color:green" class="ml-auto" v-on:click="display = 'generalinformation'">Next Section</b-button>
                                </div>
                            </div>
                            <div v-if="display === 'generalinformation'">
                                <h2>General Information</h2>
                                <p class="card-sub-title text-muted">Enter a description for the transaction and the proposed
                                    completion
                                    date.</p>
                                <div>
                                    <form ref="form" @submit.prevent="saveTransactionDetails">
                                        <div class="form-row">

                                            <div class="col-sm-12 col-md-12">
                                                <div class="form-group ">
                                                    <label for="transactionTitle" class="hec-label-required">Transaction
                                                        Title</label>
                                                    <input required type="text" class="form-control" id="transactionTitle"
                                                        v-model="transaction.title"
                                                        :class="{ 'is-invalid': $v.transaction.title.$error }"
                                                        maxlength="50">
                                                    <span v-if="!transaction.title.required"
                                                        class="invalid-feedback">Transaction Title is
                                                        required</span>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="form-row">
                                            <div class="col-sm-12 col-md-12">
                                                <div class="form-group ">
                                                    <label for="transactionDescr" class="hec-label-required">Transaction
                                                        Description</label>
                                                    <input type="text" required class="form-control" id="transactionDescr"
                                                        v-model="transaction.descr"
                                                        :class="{ 'is-invalid': $v.transaction.descr.$error }"
                                                        maxlength="255">
                                                    <span v-if="!transaction.descr.required"
                                                        class="invalid-feedback">Transaction Description is
                                                        required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col-sm-12 col-md-12">
                                                <div class="form-group ">
                                                    <label for="transactionType" class="hec-label-required">Transaction
                                                        Type</label>
                                                    <b-form-select id="transactionType" v-model="transaction.type" :options="transactionTypes"
                                                        required :class="{ 'is-invalid': this.txTypeOnChange }"
                                                        @change="validationTxTypeStatus()">
                                                        <b-form-select-option :value="null">Select Transaction
                                                            Type</b-form-select-option>
                                                    </b-form-select>
                                                    <span v-if="txTypeOnChange" class="invalid-feedback">Transaction
                                                        Type is required</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col-sm-12 col-md-6">
                                                <div class="form-group ">
                                                    <label for="propsedCompletionDate" class="hec-label-required">Proposed Completion Date</label>
                                                    <b-form-datepicker id="propsedCompletionDate"
                                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                        v-model="transaction.propsedCompletionDate"
                                                        required :class="{ 'is-invalid': this.dtProposedOnChange }"
                                                        @input="validationProposedDate()">
                                                    </b-form-datepicker>
                                                    <span v-if="dtProposedOnChange" class="invalid-feedback">Proposed Completion Date is required</span>
                                                </div>
                                            </div>
                                            <div v-if="daysDifference < 30"  class="col-sm-12 col-md-6">
                                                <div class="form-group ">
                                                    <label for="anticipatedDate">Date Transaction First Anticipated</label>
                                                    <b-form-datepicker id="anticipatedDate"
                                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                        v-model="transaction.anticipatedDate" required></b-form-datepicker>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                </div>
                                <br /><br />
                                <div class="d-flex align-items-center">
                                    <b-button variant="secondary" size="sm"
                                            v-on:click="updateTransactionDetails">Save Section</b-button>
                                    <b-button variant="link" size="sm" class="ml-auto mr-2" v-on:click="display = 'overview'" style="color:green">Previous Section</b-button>                                          
                                    <b-button variant="link" size="sm" style="color:green" v-on:click="display = 'documents'">Next Section</b-button>
                                </div>
                            </div>
                            <div v-if="display === 'documents'">
                                <h2>Documents</h2>
                                <p class="card-sub-title text-muted">Attach supporting documents for the transaction by clicking Select Document.
                                    Please complete all sections prior to attaching a Completed Transaction
                                    Document.</p>
                                <div>
                                    <h3>Completed Transaction Document</h3>
                                    <hr />

                                    <div class="d-flex flex-row">
                                        <div class="p-1">
                                            <b-button variant="secondary" size="sm" @click="handleTransDocImport">Select
                                                Document</b-button>
                                        </div>
                                        <input type="file" ref="transDocFileInput" class="d-none"
                                            @change="onTransDocFileInputChanged" @click="onTransDocFileInputClicked"
                                            accept=".xls, .xlsx, .xlsm, .csv, .ppt, .pptx, .doc, .docx, .pdf" />
                                    </div>
                                    <div class="p-2 container row justify-content-around"
                                        v-for="(txDoc, index) in this.transactionDocument" v-bind:key="index">
                                        <div class="col-4">
                                            {{ txDoc ? txDoc.file.name :
                                                'No Document' }}</div>
                                        <div class="col-4"> <b-button size="sm" variant="bg-transparent"
                                                @click="deleteTransacsDoc(index)">
                                                <b-icon icon="trash-fill"></b-icon>
                                            </b-button>
                                        </div>
                                    </div>
                                    <div class="p-2 container row justify-content-around" v-if="!this.transactionDocument">
                                        <br /><br />
                                    </div>

                                </div>
                                <br />
                                <div>
                                    <h2>Support Documents</h2>
                                    <hr />

                                    <div class="d-flex flex-row">
                                        <div class="p-1"> <b-form-select v-model="selectedSupportedDocType"
                                                :options="supportDocumentFileType"
                                                :class="{ 'is-invalid': this.docTypeOnChange }"
                                                @change="validationDocTypeStatus()">
                                                <b-form-select-option :value="null">Select Document Type</b-form-select-option>
                                            </b-form-select>

                                            <span v-if="docTypeOnChange" class="invalid-feedback">Document Type is required</span>
                                        </div>
                                        <div class="p-1"> <b-button variant="secondary" size="sm"
                                                @click="handleTransAdditionalDocImport">Select
                                                Document</b-button></div>
                                        <input type="file" multiple="multiple" ref="transDocAdditionalFileInput"
                                            class="d-none" @change="onTransAdditionalDocFileInputChanged"
                                            @click="onTransAdditionalDocFileInputClicked"
                                            accept=".xls, .xlsx, .xlsm, .csv, .ppt, .pptx, .doc, .docx, .pdf" />
                                    </div>
                                    <div class="p-2 container row justify-content-around"
                                        v-for="(aditionalTxDoc, index) in this.transactionAdditionalDocument"
                                        v-bind:key="index">
                                        <div class='col-4'>
                                            {{ aditionalTxDoc ? aditionalTxDoc.file.name :
                                                'No Document' }}</div>
                                        <div class='col-4'> <b-button size="sm" variant="bg-transparent"
                                                @click="deleteSupportingDoc(index)">
                                                <b-icon icon="trash-fill"></b-icon>
                                            </b-button>
                                        </div>
                                    </div>
                                    <div class="p-2 container row justify-content-around"
                                        v-if="this.transactionAdditionalDocument.length === 0">
                                        <br /><br />
                                    </div>
                                </div>
                                <br />
                                <div class="d-flex align-items-center">
                                    <b-button variant="secondary" size="sm" class="mr-2"
                                            v-on:click="updateDocsFiles">Save Section</b-button>
                                    <b-button variant="secondary" size="sm"
                                            v-on:click="closeTransacsDoc">Close</b-button>
                                    <b-button variant="link" class="ml-auto" size="sm" v-on:click="display = 'generalinformation'" style="color:green">Previous Section</b-button>            
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.tx-screen-main-center {
    display: flex;
}

.no-gutters>.col {
    height: 50px !important;
}

.b-calendar-grid-weekdays {
    height: 50px !important;
}
</style>

<script>
import lambdahcetx from '../../lambdahcetx';
import { required, minLength } from 'vuelidate/lib/validators';
import moment from 'moment'

export default {
    props: ['id'],
    async mounted() {
        try {
            this.loading = true;
            const getTxTypesResponse = await lambdahcetx.getHceTransactionTypes();
            this.transactionTypes = getTxTypesResponse.map(fTxType => {
                const transactionType = {
                    value: fTxType.attributeId,
                    text: fTxType.textValue1
                }
                return transactionType;
            }).sort((txType1, txType2) => txType1.text - txType2.text);

            const getTxDocTypesResponse = await lambdahcetx.getHceTransactionDocumentTypes();
            this.supportDocumentFileType = getTxDocTypesResponse.map(fTxType => {
                const transactionDocType = {
                    value: fTxType.attributeId,
                    text: fTxType.textValue1
                }
                return transactionDocType;
            }).sort((txType1, txType2) => txType1.text - txType2.text);
            const contactId = localStorage.getItem("contactId");
            const updateTxResponse = await lambdahcetx.getHceTransactionAndDocuments(this.$props.id, contactId);
            if (updateTxResponse.trasactionAdditionalDocuments) {
                for (const doc of updateTxResponse.trasactionAdditionalDocuments) {
                    this.transactionAdditionalDocument.push({
                        file: { name: doc.fileName }, documentId: doc.documentId,
                        documentTypeId: doc.documentTypeId
                    })
                }
            }
            if (updateTxResponse.trasactionDocuments) {
                for (const doc of updateTxResponse.trasactionDocuments) {
                    this.transactionDocument.push({
                        file: { name: doc.fileName }, name: doc.fileName, documentId: doc.documentId,
                        documentTypeId: doc.documentTypeId
                    });
                }
            }

            this.transaction = {
                transactionId: updateTxResponse.transaction.transactionId,
                title: updateTxResponse.transaction.transactionTitle,
                descr: updateTxResponse.transaction.transactionDesc,
                type: updateTxResponse.transaction.transactionTypeId,
                anticipatedDate: new Date(updateTxResponse.transaction.anticipationDate),
                propsedCompletionDate: new Date(updateTxResponse.transaction.proposedCompletionDate),
                createDate: new Date(updateTxResponse.transaction.createDate)
            }
        } finally {
            this.loading = false;
        }
    },
    data() {
        return {
            loading: false,
            docTypeOnChange: false,
            txTypeOnChange: false,
            dtProposedOnChange: false,
            display: 'overview',
            transaction: {
                transactionId: '',
                title: '',
                descr: '',
                type: null,
                anticipatedDate: '',
                propsedCompletionDate: '',
                createDate: ''
            },
            transactionDocument: [],
            supportingDocuments: null,
            transactionTypes: [{ value: null, text: 'Please select an option' }],
            transactionAdditionalDocument: [],
            supportDocumentFileType: [{ value: null, text: 'Select a Document Type' }],
            selectedSupportedDocType: null,
            deleteTxOrSupportDocuments: [],
            alreadyInsertedTxDocs: [],
            alreadyInsertedAdditionalSupportDocs: []
        };
    },
    validations: {
        transaction: {
            title: {
                required, minLength: minLength(1)
            },
            descr: {
                required, minLength: minLength(1)
            }
        },
        form: ['transaction'],
    },
    computed: {
        daysDifference: function() {
            const timeDifference = moment(this.transaction.propsedCompletionDate, 'yyyy-MM-DD') - moment(this.transaction.createDate, 'yyyy-MM-DD');
            return Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        }
    },
    methods: {
        isRequired(value) {
            return value ? true : 'This field is required';
        },
        focusFirstStatus() {
            var errorElements = document.querySelectorAll(".is-invalid");
            if (errorElements && errorElements.length > 0) {
                var elmnt = document.getElementById(errorElements[0].id);
                elmnt.scrollIntoView();
            }
        },
        validate() {
            this.$v.form.$touch();
            var isValid = !this.$v.form.$invalid;
            this.$emit('on-validate', this.$data, isValid);
            this.$nextTick(() => this.focusFirstStatus());
            return isValid
        },
        validationDocTypeStatus: function () {
            if (this.selectedSupportedDocType) {
                this.docTypeOnChange = false;
            } else {
                this.docTypeOnChange = true;
            }
        }, validationTxTypeStatus: function () {
            console.log(this.transaction.type);
            if (this.transaction.type) {
                this.txTypeOnChange = false;
            } else {
                this.txTypeOnChange = true;
            }
        },
        validationProposedDate: function() {
            if (this.transaction.propsedCompletionDate) {
                this.dtProposedOnChange = false;
            } else {
                this.dtProposedOnChange = true;
            }
        },
        cancelTransactionButton: function () {
            window.location.href = '/hce/home';
        },
        updateTransactionDetails: async function () {
            this.loading = true;
            this.$v.$touch();
            this.validationTxTypeStatus();
            this.validationProposedDate();
            if (this.$v.$invalid || this.txTypeOnChange || this.dtProposedOnChange) {
                this.loading = false;
                this.hasError = true;
            } else {
                const contactId = localStorage.getItem("contactId");
                const transactionId = this.$props.id;
                if (transactionId !== undefined && transactionId !== null) {
                    const aniticipagedDate = moment(this.transaction.anticipatedDate).format('yyyy-MM-DD');
                    const propsedCompletionDate = moment(this.transaction.propsedCompletionDate).format('yyyy-MM-DD');
                    const updateTxResponse = await lambdahcetx.updateHceTransaction(transactionId, this.transaction.title, this.transaction.descr, this.transaction.type, aniticipagedDate, propsedCompletionDate, contactId);
                    if (updateTxResponse != null) {
                        console.log('Transaction successfully updated....');
                    }
                }
                this.loading = false;
            }
        },
        handleTransDocImport: function (e) {
            this.$refs.transDocFileInput.click();
        },
        onTransDocFileInputClicked(e) {
            //Resolved same file multiple times upload issue
            this.$refs.transDocFileInput.value = null;
        },
        onTransAdditionalDocFileInputClicked(e) {
            //Resolved same file multiple times upload issue
            this.$refs.transDocAdditionalFileInput.value = null;
        },
        async onTransDocFileInputChanged(e) {
            for (let i = 0; i < e.target.files.length; i++) {
                let file = e.target.files[i];
                this.transactionDocument.push({ file, name: e.target.files[i].name, fileContentType: e.target.files[i].type });
            }
        },
        handleTransAdditionalDocImport: function () {
            if (this.selectedSupportedDocType) {
                this.docTypeOnChange = false;
                this.$refs.transDocAdditionalFileInput.click();
            } else {
                this.docTypeOnChange = true;
            }

        },
        async onTransAdditionalDocFileInputChanged(e) {
            for (let i = 0; i < e.target.files.length; i++) {
                let file = e.target.files[i];
                this.transactionAdditionalDocument.push({ file, type: this.selectedSupportedDocType, name: e.target.files[i].name, fileContentType: e.target.files[i].type });
            }
            this.selectedSupportedDocType = null;
        }, async updateDocsFiles() {
            this.loading = true;
            this.docTypeOnChange = false;
            const contactId = localStorage.getItem("contactId");
            const btxId = this.$props.id;
            if (!btxId) {
                this.$v.$touch();
                this.validationTxTypeStatus();
                if (this.$v.$invalid || this.txTypeOnChange) {
                    this.hasError = true;
                    this.display = "generalinformation";
                    this.loading = false;
                } else {
                    const contactId = localStorage.getItem("contactId");
                    const transactionId = this.$props.id;
                    if (transactionId !== undefined && transactionId !== null) {
                        const aniticipagedDate = moment(this.transaction.anticipatedDate).format('yyyy-MM-DD');
                        const propsedCompletionDate = moment(this.transaction.propsedCompletionDate).format('yyyy-MM-DD');
                        const updateTxResponse = await lambdahcetx.updateHceTransaction(transactionId, this.transaction.title, this.transaction.descr, this.transaction.type, aniticipagedDate, propsedCompletionDate, contactId);
                        if (updateTxResponse != null) {
                            console.log('Transaction successfully updated....');
                        }
                    }
                }
            }
            const transactionId = this.$props.id;
            if (transactionId) {
                //Deleting documents
                if (this.deleteTxOrSupportDocuments.length > 0) {
                    const deleteTxDocs = await lambdahcetx.deleteHceTransactionDocuments(JSON.stringify(this.deleteTxOrSupportDocuments));
                    if (deleteTxDocs) {
                        console.log("Documents deleted successfully");
                    }
                    this.deleteTxOrSupportDocuments = [];
                }
                if (this.transactionDocument) {
                    for (let i = 0; i < this.transactionDocument.length; i++) {
                        if (this.transactionDocument[i] && !this.transactionDocument[i].documentId) {
                            const isTxDocInserted = this.alreadyInsertedTxDocs.find((txDoc) => txDoc.name === this.transactionDocument[i].name);
                            if (!isTxDocInserted) {
                                const reader = new FileReader();
                                reader.onloadend = async () => {
                                    const base64string = reader.result;
                                    const insertTxDocFileResponse = await lambdahcetx.uploadHceTransactionDocuments(transactionId, contactId, 2, base64string, this.transactionDocument[i].name, this.transactionDocument[i].fileContentType);
                                    if (insertTxDocFileResponse) {
                                        console.log(insertTxDocFileResponse);
                                        this.alreadyInsertedTxDocs.push({ name: this.transactionDocument[i].name });
                                    }
                                };
                                if (this.transactionDocument[i].file) {
                                    reader.readAsDataURL(this.transactionDocument[i].file);
                                }
                            }
                        }
                    }
                    if (this.transactionAdditionalDocument) {
                        for (let i = 0; i < this.transactionAdditionalDocument.length; i++) {
                            if (this.transactionAdditionalDocument[i] && !this.transactionAdditionalDocument[i].documentId) {
                                const isSupportDocInserted = this.alreadyInsertedAdditionalSupportDocs.find((sDoc) => sDoc.name === this.transactionAdditionalDocument[i].name);
                                if (!isSupportDocInserted) {
                                    const reader = new FileReader();
                                    reader.onloadend = async () => {
                                        const base64string = reader.result;
                                        const insertTxDocFileResponse = await lambdahcetx.uploadHceTransactionDocuments(transactionId, contactId, this.transactionAdditionalDocument[i].type, base64string, this.transactionAdditionalDocument[i].name, this.transactionAdditionalDocument[i].fileContentType);
                                        if (insertTxDocFileResponse) {
                                            console.log(insertTxDocFileResponse);
                                            this.alreadyInsertedAdditionalSupportDocs.push({ name: this.transactionAdditionalDocument[i].name });
                                        }
                                    };
                                    if (this.transactionAdditionalDocument[i].file) {
                                        reader.readAsDataURL(this.transactionAdditionalDocument[i].file);
                                    }
                                }

                            }
                        }
                    }
                    this.loading = false;
                }
            }
        },
        deleteSupportingDoc(index) {
            if (this.transactionAdditionalDocument[index].documentId) {
                this.deleteTxOrSupportDocuments.push({ documentId: this.transactionAdditionalDocument[index].documentId, fileName: this.transactionAdditionalDocument[index].name, contactId: localStorage.getItem("contactId") });
            }
            this.transactionAdditionalDocument.splice(index, 1);
        },
        deleteTransacsDoc(index) {
            if (this.transactionDocument[index].documentId) {
                this.deleteTxOrSupportDocuments.push({ documentId: this.transactionDocument[index].documentId, fileName: this.transactionDocument[index].name, contactId: localStorage.getItem("contactId") });
            }
            this.transactionDocument.splice(index, 1);
        },
        closeTransacsDoc() {
            window.location.href = '/hce/home';
        }
    }
}
</script>
